import { render, staticRenderFns } from "./BuyerPreferencesLink.vue?vue&type=template&id=72a45df8"
import script from "./BuyerPreferencesLink.vue?vue&type=script&lang=js"
export * from "./BuyerPreferencesLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports